export const checkinList = {
  group: {
    sectionTitle: "Associated check-ins",
    registrationForm: "Registration form",
    registrationFormHint: "A single document with the lead guest and their companions",
    registrationFormEmpty: "No check-in has been completed for this booking yet.",
    registrationFormError: "The form could not be generated. Please try again.",
    emptyState: "No associated check-ins.",
    name: "Name",
    phone: "Phone",
    document: "Document",
    notAvailable: "Not available",
    syncSent: "Sent to immigration",
    syncError: "Immigration error",
    syncPending: "Pending submission",
    moreInfo: "More information",
    email: "Email",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Document type",
    supportNumber: "Support number",
    documentBack: "Back",
    identityNoMatch: "Faces do not match",
    identityStored: "No face comparison",
    identityError: "Comparison failed",
    identityNoPhotos: "Photos aren't kept in this country: only the result remains.",
    identityVerification: "Identity verification",
    tapToEnlarge: "Tap to enlarge",
    view: "View",
    download: "Download",
    selfie: "Selfie",
    minorData: "Minor's details",
    relationship: "Relationship:",
    noPhotos: "No photos attached.",
    minorDocument: "Minor's document",
    authorization: "Authorization",
    minorAuthorization: "Minor's authorization",
    specification: "Specification:",
    additionalInfo: "Additional information",
    nationality: "Nationality",
    birthDate: "Date of birth",
    ageYears: "({age} years old)",
    gender: "Gender",
    female: "Female",
    male: "Male",
    countryResidence: "Country of residence",
    cityResidence: "City of residence",
    address: "Address",
    zipCode: "Postal code",
    sesBatchId: "SES batch ID",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Country of birth",
    docIssuePlace: "Document issue place",
    signedDocument: "Signed document",
    edit: "Edit",
    remove: "Delete",
    previewAlt: "Preview",
    previewFallbackTitle: "Image",
    docTypes: {
      passport: "Passport",
      passportOrdinary: "Ordinary passport",
      passportService: "Service passport",
      passportDiplomatic: "Diplomatic passport",
      idCard: "ID card",
      nie: "NIE",
      idCardElectronic: "Electronic ID card",
      idDiplomatic: "Diplomatic ID document",
      citizenshipCard: "Citizenship card",
      foreignerCard: "Foreigner ID card",
      drivingLicense: "Driving license",
      nauticalLicense: "Boating license",
      specialResidencePermit: "Special residence permit",
      foreignerDocument: "Foreigner document",
      foreignDocument: "Foreign document",
      diplomaticCard: "Diplomatic card",
      refugeeTravelDocument: "Refugee travel document",
      otherDocument: "Other document",
    },
  },
  individual: {
    title: "Guest details",
    phone: "Phone",
    email: "Email",
    notAvailable: "Not available",
    lodging: "Stay",
    docType: "Document type",
    docNumber: "Document number",
    supportNumber: "Support number",
    identityVerification: "Identity verification",
    document: "Document",
    tapToEnlarge: "Tap to enlarge",
    view: "View",
    download: "Download",
    selfie: "Selfie",
    minorData: "Minor's details",
    relationship: "Relationship:",
    noPhotos: "No photos attached.",
    minorDocument: "Minor's document",
    authorization: "Authorization",
    minorAuthorization: "Minor's authorization",
    specification: "Specification:",
    additionalInfo: "Additional information",
    nationality: "Nationality",
    birthDate: "Date of birth",
    ageYears: "({age} years old)",
    gender: "Gender",
    female: "Female",
    male: "Male",
    countryResidence: "Country of residence",
    cityResidence: "City of residence",
    address: "Address",
    zipCode: "Postal code",
    sesBatchId: "SES batch ID",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Country of birth",
    docIssuePlace: "Document issue place",
    signedDocument: "Signed document",
    edit: "Edit",
    previewAlt: "Preview",
    previewFallbackTitle: "Image",
    docTypes: {
      passport: "Passport",
      passportOrdinary: "Ordinary passport",
      passportService: "Service passport",
      passportDiplomatic: "Diplomatic passport",
      idCard: "ID card",
      nie: "NIE",
      idCardElectronic: "Electronic ID card",
      idDiplomatic: "Diplomatic ID document",
      citizenshipCard: "Citizenship card",
      foreignerCard: "Foreigner ID card",
      drivingLicense: "Driving license",
      nauticalLicense: "Boating license",
      specialResidencePermit: "Special residence permit",
      foreignerDocument: "Foreigner document",
      foreignDocument: "Foreign document",
      diplomaticCard: "Diplomatic card",
      refugeeTravelDocument: "Refugee travel document",
      otherDocument: "Other document",
    },
  },
};
